import { render } from "./hz-table.vue?vue&type=template&id=5832cc84"
import script from "./hz-table.vue?vue&type=script&setup=true&lang=js"
export * from "./hz-table.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/table/hz-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5832cc84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5832cc84', __exports__)) {
    api.reload('5832cc84', __exports__)
  }
  
  module.hot.accept("./hz-table.vue?vue&type=template&id=5832cc84", () => {
    api.rerender('5832cc84', render)
  })

}


export default __exports__